/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { bool, object } from 'prop-types';
import { useUIDSeed } from 'react-uid';

import Dropdown from './Partials/Dropdown';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: '2px',
    },
    text: {
        margin: '8px 0',
    },
    marginTop: {
        marginTop: '28px',
    },
}));

const OfferDropdownDesign = ({ data, notFirst }) => {
    const offers = data?.offer || [];
    const classes = useStyles();
    const seed = useUIDSeed();

    return (
        <div className={`${classes.root} ${notFirst ? classes.marginTop : ''}`}>
            {offers.map((item) => (
                <Dropdown item={item} key={seed(item)} />
            ))}
        </div>
    );
};

OfferDropdownDesign.propTypes = {
    data: object,
    notFirst: bool,
};

OfferDropdownDesign.defaultProps = {
    data: {},
    notFirst: false,
};

export default OfferDropdownDesign;
